import { ColDef, SuppressKeyboardEventParams } from 'ag-grid-community';

export const defaultColumn: ColDef = {
  colId: '',
  headerName: '',
  field: '',
  sortable: true,
  filter: false,
  menuTabs: [],
  resizable: true,
  flex: 1,
  wrapHeaderText: true,
  autoHeaderHeight: true,
  suppressKeyboardEvent: suppressNavigation,
};

function suppressNavigation(params: SuppressKeyboardEventParams) {
  var KEY_ENTER = 'Enter';
  var event = params.event;
  var key = event.key;
  var suppress = key === KEY_ENTER;
  return suppress;
}

export const registeredIconIndex = 5;
export const PEF_WEIGHTED = 'Contribution by PEF categories (Weighted)';
export const PEF_NORMALIZED = 'Contribution by PEF categories (Normalized)';
export const grid_widths_map = {
  icon_xs: 20,
  icon_sm: 30,
  icon_md: 40,
  icon_lg: 60,
  icon_xl: 80,
  sm_column_xxxm: 35,
  sm_column_xxm: 100,
  sm_column_xs: 90,
  sm_column_xss: 110,
  sm_column_xm: 150,
  sm_column_xmd: 180,
  sm_column_sm: 200,
  sm_column_lg: 250,
  sm_column_xl: 300,
  sm_column_xxl: 350,
  lg_column_xxm: 400,
  lg_column_sm: 450,
  lg_column_lg: 500,
  lg_column_xl: 550,
  lg_column_xxl: 600,
};

export const guideTourStep2Str: string =
  "Click here to begin a new project. Select 'Packaging' to model a simple Packaging assessment. Select 'Product' to model the contents used within the Packaging project.";
export const guideTourStep5Str: string =
  "The side panel displays the life cycle stages that have been accounted for in the Project settings. See 'Project scope' for three preset scope options.";
export const guideTourStep6Str: string =
  "The 'Report' tab contains all your results and reporting requirements. The 'Interpretation' stage is for advanced reporting requirements.";
export const guideTourStep11Str: string =
  "Package production processes prior to the point of 'Filling' are modelled at the 'Materials' and 'Conversion' stages.";
export const guideTourStep12Str: string =
  "Processes from 'Filling' through to supply chain to the 'Consumer' are modelled from 'Product'. This section is used to account for product wastage, transport mass and other impacts.";
export const guideTourStep13Str: string =
  "'End-of-Life' is now a separate stage, which includes 'Retail' end-of-life, 'Consumer' end-of-life and reuse.";
export const guideTourStep14Str: string =
  'Click here to start adding details for your first package.';
export const guideTourStep26Str: string =
  "Downstream supply chain impacts can be modelled in the 'Filling', 'Wholesale', 'Retail' and 'Consumer' stages. You can manoeuvre directly to any stage from these tabs or go on step by step. These stages are not mandatory.";
export const guideTourStep30Str: string = "'End-of-life' now has its own stage.";
export const guideTourStep15Str: string =
  "Use this feature for 'Organization packaging footprint'. This feature is not mandatory.";
export const eolGuidedTourStepStr: string =
  "Add reuse data by selecting components reused at the 'Retail' level (pallet, traded pack or merchandizing units) or the 'Consumer' level (retail or sub-retail units).";
export const ExpireSoonStr = 'Session expiring soon';
export const ExpireSoonDescriptionStr = 'Your session will expire soon. Do you want to extend it?';

export const packagingSubMenu = 'packaging';
export const productSubMenu = 'product';

export const ProjectScopeTypeEnum = [
  { Description: 'Packaging LC stages', Display: 'Packaging LC stages', PackagingLCStages: 1 },
  { Description: 'Packaging Levels', Display: 'Packaging Levels', PackagingLCStages: 2 },
  { Description: 'Product LC stages', Display: 'Product LC stages', PackagingLCStages: 3 },
];

export const ScopePresetsEnum = [
  {
    Description: 'Simple retail package ignoring product',
    Display: 'Simple retail package ignoring product',
    SimpleRetailPackageIgnoringProduct: 1,
    id: 1,
  },
  {
    Description: 'Retail, traded and pallet package supply chain logistics',
    Display: 'Retail, traded and pallet package supply chain logistics',
    RetailTradedAndPalletPackageSupplyChainLogistics: 2,
    id: 2,
  },
  {
    Description: 'Full package and product LCA',
    Display: 'Full package and product LCA',
    FullPackageAndProductLCA: 3,
    id: 3,
  },
];
export const StorageTypeEnum = {
  Wholesale: 1,
  Retail: 2,
  Consumer: 3,
};
export const commonEnum = {
  manualLocation: 2,
  manualDistance: 3,
  customDistance: 4,
  reviewerName: 'Reviewer',
  dummyRecord: {
    id: 0,
    name: '-- No custom report --',
    disabled: true,
  },
  barChartOption: 2,
  shipName: 'ship, international',
  airDomesticName: 'air, domestic',
  airName: 'air, international',
  reportABug: 'Report a bug',
  opacity: 0.3,
  AIR_INTERNATIONAL: 22,
  SHIP_INTERNATIONAL: 19,
  AIR_DOMESTIC: 21,
};

export const ImpactCategoriesEnum = {
  CarbonFootprintReport: 1,
  CarbonadLandandWater: 2,
  Piqet3Legacy: 3,
  Pefindicators: 4,
  All22Indicators: 5,
  Customcategories: 6,
  Customizecategories: 7,
  All38IndicatorsEmissionsSingleScore: 8,
  PIQET42LegacyIndicators: 9,
  All36EmissionsIndicators: 11,
  Piqet3legacycategories: 12,
  Globalpackagingprotocol: 13,
  Pefweightedindicators: 14,
  Expandedtoxicityindicators: 15,
  Expandedclimatechangeindicators: 16,
  PEFCategoriesWithTOX: 17,
  PEFCategoriesWithoutTOX: 18,
  PEFCategoriesWithTOX_Weighted: 19,
  PEFCategoriesWithoutTOX_Weighted: 20,
  PEFWeightedIndicatorsWithToxicity: 21,
  PEFWeightedIndicatorsWithoutToxicity: 22,
};

export const ReportTypeEnum = {
  MaterialImpacts: 1,
  ConversionImpact: 2,
  TransporttoConvertor: 3,
  TransportationtoFiller: 4,
  ReuseTransportation: 5,
  ReuseProcess: 6,
  ManufactureContribution: 7,
  FillingProcessContribution: 8,
  WholesaleProcessContribution: 9,
  RetailProcessContribution: 10,
  ConsumerContribution: 11,
  ReuseProcessContribution: 12,
  CustomContribution: 13,
  CustomContributionAnalysisHighLevel: 14,
  EndOfLifeImpact: 15,
  ContributionbyPackagingLevel: 16,
  ContributionbyProductLosses: 17,
  ContributionbyComponent: 18,
  ContributionbyIngredient: 19,
  ContributionofTransport: 20,
  PEF_Categories_tox: 21,
  PEF_Categories_without_tox: 22,
};

export const DropMessageTypeEnum = {
  Success: 0,
  Error: 1,
  Warning: 2,
  Info: 3,
  None: 4,
  LoginValidation: 5,
  directLogin: 6,
  MFAEnabled: 7,
};

export enum VerificationStatusEnum {
  Pending = 1,
  UnderReview = 2,
  Verified = 3,
  Rejected = 4,
}

export enum AutomationStatusEnum {
  Pending = 0,
  InProgress = 1,
  Completed = 2,
  NotFound = 3,
}

export const SignupSourceTypeArray = [
  { id: 1, name: 'Conference / trade event' },
  { id: 2, name: 'LinkedIn' },
  { id: 3, name: 'Word of mouth' },
  { id: 4, name: 'Google' },
  { id: 5, name: 'Other' },
];

export enum SignupSourceType {
  ConferenceTradeEvent = 1,
  LinkedIn = 2,
  WordOfMouth = 3,
  Google = 4,
  Other = 5,
}

export const allItemsPayload = {
  search: {
    columnNameList: [],
    value: '',
  },
  columns: [
    {
      searchable: true,
      name: 'Name',
      orderable: true,
      data: 'Name',
    },
    {
      searchable: true,
      name: 'StartDate',
      orderable: true,
      data: 'StartDate',
    },
    {
      searchable: true,
      name: 'ExpDate',
      orderable: true,
      data: 'ExpDate',
    },
    {
      searchable: true,
      name: 'CountryName',
      orderable: true,
      data: 'CountryName',
    },
    {
      searchable: true,
      name: 'Status',
      orderable: true,
      data: 'Status',
    },
  ],
  order: [
    {
      columnName: 'Name',
      dir: 'Asc',
    },
  ],
  start: 0,
  length: -1,
  draw: 1,
};

export const rolesModuleName = {
  project: 'Project',
  packageScenario: 'Packaging',
  productScenario: 'Product',
  customFilling: 'Filling',
  customConversion: 'Conversion',
  customWasteScenario: 'Waste scenarios',
  customTrucks: 'Trucks',
  customTransportScenario: 'Transport chains',
  customStorage: 'Storage',
  customMaterial: 'Materials',
  customReuse: 'Reuse',
  customEolScenario: 'EOL scenarios',
  myOrganizationManageUser: 'Manage users',
  myOrganizationManageTeam: 'Manage teams',
  myOrganizationProjectReportSetting: 'Project report settings',
  myOrganizationProjectWorkFlow: 'Project workflow',
  myOrganizationScenarioWorkFlow: 'Scenario workflow',
  myOrganizationProductGroup: 'Product groups',
  myOrganizationCustomCategory: 'Custom Category',
  myOrganizationProductCategoryTitles: 'Product category titles',
  myOrganizationProductCategoryItems: 'Product category items',
  myOrganizationPrefrences: 'Organization preferences',
  myOrganizationSSO: 'Login settings',
  AdministratorUser: 'User',
  AdministratorTeams: 'Teams',
  AdministratorOrganizations: 'Organizations',
  AdministratorLoginlogs: 'Login logs',
  AdministratorProjects: 'Projects',
  AdministratorMaterials: 'Custom materials',
  AdministratorConversion: 'Custom Conversion',
  AdministratorTrucks: 'Custom Trucks',
  AdministratorFilling: 'Custom Filling',
  AdministratorStorage: 'Custom Storage',
  AdministratorReuse: 'Custom Reuse',
  AdministratorWasteScenarios: 'Waste Scenarios',
  AdministratorTransportScenarios: 'Custom transport chain',
  AdvancedRoles: 'Roles',
  AdvancedLogEntires: 'Log entires',
  AdvancedImport: 'Import',
  AdvancedCountry: 'Country',
  AdvancedState: 'State',
  AdvancedCity: 'City',
  AdvancedNews: 'News',
  AdvancedExportLogs: 'Export Log',
  DataManageConvertingProcess: 'Converting Processes',
  DataManageMiscSimulation: 'Misc Simulation',
  DataManageMaterialImpactMaterial: 'Materials',
  DataManageMaterialImpactIngredients: 'Ingredients',
  DataManageMaterialImpactRecycleImpact: 'Recycled material impact',
  DataManageProcessingDataConversion: 'Conversion',
  DataManageProcessingDataAreabasedConversion: 'Area based conversions ',
  DataManageProcessingDataTransport: 'Transport',
  DataManageProcessingDataRefrigeratedTruck: 'Refrigerated Trucks',
  DataManageProcessingDataCustomTruck: 'Custom trucks',
  DataManageProcessingDataEnergyandancillary: 'Energy and ancillary',
  DataManageProcessingDataCustomConversion: 'Custom conversion',
  DataManageProcessingDataStorage: ' Storage',
  DataManageProcessingDataWaste: ' Waste',
  DataManageEOLRC: 'EOL-RC',
  DataManageEOLLF: 'EOL-LF',
  DataManageEOLCC: 'EOL-CC',
  DataManageEOLHC: 'EOL-HC',
  DataManageEOLER: 'EOL-ER',
  DataManageEOLIC: 'EOL-IC',
  DataManageEOLOD: 'EOL-OD',
  DataManageEOLSW: 'EOL-SW',
  DataManageEOLSE: 'EOL-SE',
  DataManageEOLLT: 'EOL-LT',
  DataManageEOLAD: 'EOL-AD',
  DataManageEOLOR: 'EOL-OR',
  DataManageEOLCR: 'EOL-CR',
  DataManageEOLPG: 'EOL-PG',
  DataManageEOLOB: 'EOL-OB',
  DataManageEOLNO: 'EOL-NO',
  DataManageConversionMapping: 'Conversion mapping',
  DataManageRecycledContent: 'Recycled content',
  DataManageEOLrates: 'EOL Rates',
  DataManageEOLconsumers: 'EOL Consumers',
  DataManageProductPackageRatio: 'Product package ratio',
  DataManageMaterialTypes: 'Material types',
  DataManageOtherDataCompostability: 'Compostability',
  DataManageOtherDataRecyclability: 'Recyclability',
  DataManageOtherDataCombustibility: 'Combustibility',
  DataManageOtherDataCircularEconomy: 'Circular economy parameters',
  DataManageOtherDataCountryIdentifier: 'Country identifiers',
  DataManageOtherDataPallettypes: 'Pallet Types',
  DataManageOtherDataProjectStatus: 'Project Status',
  DataManageOtherDataScenarioStatus: 'Scenario Status',
  DataManageOtherDataEquivalencyUnits: 'Equivalency units',
  piqetTemplate: 'Piqet Template',
  customTemplate: 'Custom Template',
  exportLogs: 'Export Logs',
  orgPackagingFootPrint: 'Org. packaging footprint report',
  addInternalData: 'Add internal data',
};
export const mainModuleName = {
  customModule: 'Custom',
  myOrganizationModule: 'Preferences',
  manageOrganizationModule: 'Manage Organization',
  administratorModule: 'Administrator',
  projectsModule: 'Projects',
  productsModule: 'Products',
  dataManageMentModule: 'Data Management',
  userManagementModule: 'User Management',
  projectManagementModule: 'Project Management',
  advancedModule: 'Advanced',
  importPreferences: 'Org. project import',
};

export const subModuleName = {
  materialImpactDataModule: ' Materials impact data',
  ProcessingDataModule: 'Processing data ',
  EOLDataModule: 'EOL data',
  otherDataModule: 'Other data',
};

// Mirrors the backend NewReportFormatEnum at
// PIQET-Backend/Business/PIQET.Business/Enums/General/NewReportFormatEnum.cs
// Use these constants instead of magic numbers when comparing the
// `newFormateList` dropdown selection.
export const NewReportFormatEnum = {
  LCAReport: 1,
  LCAPresentation: 2,
  ExportRawData: 3,
  ExportProjectSummaryQuadpack: 4,
  ExportProjectSummaryAllOrganization: 5,
  ExportRawDataNew: 6,
} as const;

export const ReportFormatEnum = [
  {
    id: 4,
    display: 'Compact report',
    description: 'Compact Report',
  },
  {
    id: 3,
    display: 'Full report',
    description: 'Full Report',
  },
  {
    id: 5,
    display: 'Excel summary report',
    description: 'Excel Summary Report',
  },
  {
    id: 6,
    display: 'Product waste report',
    description: 'Product waste report',
  },
  {
    id: 7,
    display: 'Simple Slides Deck',
    description: 'Slides',
  },
  {
    id: 10,
    display: 'Slides Report',
    description: 'Slides Details',
  },
  {
    id: 8,
    display: 'Carbon Footprint Report',
    description: 'Carbon Footprint Report',
  },
  {
    id: 11,
    display: 'ISO 14044 LCA Report',
    description: 'ISO 14044 LCA Report',
  },
  {
    id: 12,
    display: 'PIQET Summary Report',
    description: 'PIQET Summary Report',
  },
  {
    id: 0,
    display: 'Custom report',
    description: 'Custom report',
  },
];

export const palletReusableOpts = [
  {
    name: 'Yes',
    val: true,
  },
  {
    name: 'No',
    val: false,
  },
];

export const ReuseList = [
  {
    name: '0 reuse',
    reuseable: false,
  },
  {
    name: '1 reuse',
    reuseable: true,
  },
  {
    name: '2 reuses',
    reuseable: true,
  },
  {
    name: '3 reuses',
    reuseable: true,
  },
  {
    name: '4 reuses',
    reuseable: true,
  },
  {
    name: '5 reuses',
    reuseable: true,
  },
  {
    name: '50+ reuses',
    reuseable: true,
  },
];

export const keysToExclude = [
  'index',
  'isCustomMaterial',
  'materialId',
  'materialName',
  'scenarioId',
  'enableEditing',
  'componentName',
  'componentId',
  'eolEntrySource',
];

export const orgCertificationsEnum = [
  { id: 1, name: 'certOne', typeId: 1, typeName: 'Certification 1' },
  { id: 2, name: 'certTwo', typeId: 2, typeName: 'Certification 2' },
  { id: 3, name: 'certThree', typeId: 3, typeName: 'Certification 3' },
];

export const iconConfigsArr: any = [
  { color: 'rgb(255, 46, 52)', title: 'Poor', value: 4 },
  { color: 'rgb(255, 155, 20)', title: 'Fair', value: 3 },
  { color: 'rgb(20, 232, 5)', title: 'Good', value: 2 },
  { color: 'rgb(5, 232, 250)', title: 'Very good', value: 1 },
];
export const reviewColorList: string[] = ['Very good', 'Good', 'Fair', 'Poor'];
export const circleColors: string[] = ['#05E8FA', '#14E805', '#FF9B14', '#FF2E34'];

export const recycledContent = [
  { id: 1, name: 'Material default', typeId: 1 },
  { id: 2, name: 'None', typeId: 2 },
  { id: 3, name: 'Open loop only', typeId: 3 },
];

export const recycledContentPreferences = [
  { id: 1, name: 'Regionalized recycled content default' },
  { id: 2, name: 'Global average recycled content default' },
  { id: 3, name: 'No recycled content default' },
];

export const AFactorMethodTypeEnum = [
  { id: 1, name: 'PEF method' },
  { id: 2, name: 'PIQET default' },
  { id: 3, name: 'Custom' },
];

export const delayedGTSteps = [3, 5, 6, 7, 9, 10, 11, 14, 17, 18, 19, 20, 23];

export const advancedTourSteps = [
  'adv-1',
  'adv-2',
  'adv-3',
  'adv-4',
  'adv-5',
  'adv-6',
  'adv-7',
  'adv-8',
  'adv-9',
  'adv-10',
  'adv-12',
  'adv-13',
  'adv-14',
  'adv-15',
  'adv-16',
  'adv-17',
  'adv-18',
  'adv-19',
];

export const guideTourSteps = [
  'step1@dashboard',
  'step2',
  'step3',
  'step4@dashboard',
  `step5-1`,
  'step5-2',
  'step6',
  `step7`,
  'step11-materials',
  'step11-product',
  'step11-end-of-life',
  'step12',
  'step13',
  'step11-configuration',
  'step15',
  'step16',
  'step17',
  'step19',
  'step20',
  'step21',
  'step22',
  'step11-filling',
  'step26',
  'step27',
  'step28-chart-at-glance',
  'step28-report-generation',
  // Add more tour steps as needed
];

export const orgFootprintTourSteps = [
  'org-step-1',
  'org-step-2',
  'org-step-3',
  'org-step-4',
  'org-step-5',
  'org-step-6',
  'org-step-7',
  'org-step-8',
  'org-step-9',
  'org-step-10',
  'org-step-11',
  'org-step-12',
];

export const delayedOrgSteps = [1, 2, 3, 8, 12];

export const internalDataGridData = [
  {
    id: 90763,
    scenarioId: 212570,
    productId: 0,
    scenarioCode: 'S001234570480-12/Jun/03',
    productCode: '',
    department: '',
    category: 'Sample category',
    subCategory: '',
    annualVolume: '0',
    createdBy: 2,
    uuid: 197541,
    organizationId: 110,
    modifiedAt: '0001-01-01T00:00:00',
    scenarioName: '3434',
    productName: '',
    organizationName: 'Validation projects',
    projectName: 'Internal sample project',
    projectCode: 'P0020344-13/Mar/03',
    code: 'INID0012209-14/Jun/03',
  },
];

export const unitList = [
  { id: 1, name: 'g' },
  { id: 2, name: 'ml' },
];

export interface OrganizationSettingViewModel {
  ReportSettingId: Number;
  ReportFormatId: Number;
  ScopeId: Array<Number>;
  Name?: String;
}

export const emailRegex: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

// MIME Type Constants
export const MIME_TYPES = {
  APPLICATION_JSON: 'application/json',
  APPLICATION_PDF: 'application/pdf',
  TEXT_HTML: 'text/html',
} as const;

export const lcaPresentationId = '2';

export const noReportConfigTxt =
  'No configuration found for the selected report. Please set it up to proceed.';
export const materialCircularityIndex = 'Material circularity index';

export const GuideTourEnum = {
  BasicTour: 1,
  AdvancedTour: 2,
  OrganizationalFootprintTour: 3,
  ComponentTour: 4,
  FillingTour: 5,
  WholesaleTour: 6,
  InternalDataTour: 7,
};
export const palletPackagingLevelId = 5;
export const welcomeText = 'Welcome to PIQET 5!';
export const orgPrefsReminder = 'Now one last thing!';
export const reviewPrefsTxt =
  'Please review your T&Cs in "Organization Preferences" under the "Preferences" dropdown menu.';

export const updateGTStatusEndpoint = '/User/UpdateGuideTourStatus';
export const getAllCityEndpoint = '/City/GetAllCity';
export const EN_LOCALE = 'en-US';
export const percentReuseEOLerr = 'Percentage of reuse is required';
export const minPercentReuseEOLerr = "Percentage of reuse can't be less than 0.1%";
export const noOfTripsErr = 'Number of trips is required';
export const minNoOfTripsErr = "Number of trips can't be less than 2";
export const backToDashboardStr = 'Back to dashboard';
export const imageAccessStr = "May PIQET use your organization's logo in marketing materials?";

export const DISABLED_TRANSPORT_MESSAGE = 'Select a {type} to enable the transport section';
export const superAdminRoleStr = 'super admin';
export const apiAccessorRoleStr = 'LCA API User';
export const adminRoleStr = 'admin';
export const DISTANCE_KM_LABEL = 'Distance (km)';
export const DELETE_RECORD_LABEL =
  'Do you really want to delete this record? This process cannot be undone.';
export const LICENSE_LEVEL_LABEL = 'Do you want to change the license level?';
export const SIMULTANEOUS_LOGIN_DETECTED_TEXT =
  "You've been logged out due to simultaneous login detected. Redirecting in [<b></b>] seconds...";
export const SIMULTANEOUS_LOGIN_DETECTED_TITLE = 'Simultaneous login detected';
export const LOGOUT_TITLE = 'Session expired';
export const LOGOUT_TEXT = 'Logging out in [<b></b>] seconds...';
export const SUPER_ADMIN_DELETE_RECORD_LABEL =
  'Do you really want to delete this record? This process cannot be undone, and all references to this supplier will also be deleted.';
export const dblclickTooltipDef = 'Double-click to edit or view details.';
export const dblclickDownloadTooltipDef = 'Double-click to download the project details.';
export const UPDATE_USER = 'Update user';
export const ADD_USER = 'Add new user';
export const clickTooltipDef = 'Click to edit or view details.';
export const teamIcn = `bi bi-people-fill`;
export const memberIcn = `bi bi-person-fill`;
export const emailIcn = `bi bi-envelope-at-fill`;
export const loaderMessage = 'Hold on tight.. This may take a minute or two.';
export const sensitivityLoaderMessage = 'Hold on tight, this may take up to 5 minutes.';
export const purchaseThanksStr = 'purchase-thanks';
export const trialActiveStr = 'trial-activated';
export const purchaseThanksPageTitle = 'Thank You | PIQET';
export const registerPageTitle = 'Register | PIQET';
export const trialActivePageTitle = 'Trial Activated | PIQET';
export const paymentFailedPageTitle = 'Payment Failed | PIQET';
export const PIQET = 'PIQET';
export const PRODUCT_MANUFACTURE_IMPACT = 'product-manufacture-impact';
export const ADMIN_EOL_CONSUMER = 'admin-eol-consumers';

export interface TreeNode {
  name: string;
  members?: TreeNode[];
  checked?: boolean;
  expanded?: boolean;
}

export const ShareReportUserType = {
  Teams: 1,
  Members: 2,
  Others: 3,
  Self: 4,
};

export const noTextValue = '-';
export interface OtpEventData {
  otp: number;
  userId: string;
}

export const userStatus = {
  NotRegistered: 0,
  Purchased: 1,
  Trial: 2,
};

export const SessionExpiredMessage = 'Your session has expired. Please log in again.';

//Import project
export class GeneralInformation {
  public projectName: string = '';
  public share: string = '';
  public teamName: string = '';
  public defaultCountry: string = '';
  public processLocations: string = '';
  public turnOnCosts: string = '';
  public projectScope: string = '';
  public productLoss: string = '';
  public goalAndScope: string = '';
}

export class ScenarioSpecificData {
  public scenarioName: string = '';
  public supplierName: string = '';
  public nominalCapacity: string = '';
  public piqetVersion: string = '';
  public description: string = '';
  public productSectorData: string = '';
  public massVolumeRetailPack: string = '';
  public annualRetailVolumeUnits: string = '';
  public scenarioNamePackaging: string = '';
  public compReference: string = '';
  public qpPackComponentCode: string = '';
  public piqetProjectCode: string = '';
  public endOfLifeCountry: string = '';
  public year: string = '';
  public uuid: string = '';
  public department: string = '';
  public category: string = '';
  public subCategory: string = '';
  public unitsPerBox: string = '';
  public boxesPerLayer: string = '';
  public layersPerPallet: string = '';
  public totalWeightPerBox: string = '';
  public totalHeight: string = '';
  public totalWeight: string = '';
  public supplierComments: string = '';
  public productType: string = '';
  public packDescription: string = '';
  public material: string = '';
  public renewableEnergy: string = '';
  public manufacturedEMEA: string = '';
  public supplierItemCode: string = '';
  public packCode: string = '';
  [key: string]: any;
  packagingLevelDetail: PackagingLevelDetail[] = [];
  componentDetails: ComponentDetails[] = [];
}

export class TransportLeg {
  public transportMode: string = '';
  public originLocation: string = ''; // "City, State, Country" format (Leg 1 only)
  public destinationLocation: string = ''; // "City, State, Country" format
}

export class ComponentDetails {
  public type: string = '';
  public category: string = '';
  public componentName: string = '';
  public material: string = '';
  public recyclingPathway: string = '';
  public contentRecycled: string = '';
  public weightVirgin: string = '';
  public weightOfPCR: string = '';
  public materialOrigin: string = '';
  public isAreaBasedConversion: boolean = false;
  public conversionPlace: string = '';
  public conversionProcess: string = '';
  public areaCm2: number = 0;
  public reuse: string = '';
  public noOfTrips: string = '';
  public transportLegs: TransportLeg[] = [];
  // Tracks which template format this component was parsed from so the
  // validator can use the correct cell-reference column offsets in error messages.
  public templateVersion?: 'old' | 'new';
  [key: string]: any;
}

export class ImportProject {
  public generalInformation: GeneralInformation = new GeneralInformation();
  public scenarioSpecificData: ScenarioSpecificData[] = [];
}

export const ShareOption = {
  NoOneKeepItPrivate: 'No one keep it private',
  EveryoneInMyOrganization: 'Everyone in my organization',
  OneOfMyTeam: 'One of my team',
};

export const ShareOptionIds = {
  NoOneKeepItPrivate: 1,
  EveryoneInMyOrganization: 2,
  OneOfMyTeam: 2,
};

export const ProjectScope = {
  SimpleRetailPackage: 'Simple retail package ignoring product',
  RetailTradedPackage: 'Retail, traded and pallet package supply chain logistics',
  FullPackageAndProductLCA: 'Full package and product LCA',
} as const;

export class ProjectDetails {
  public packageAccountedProductId: number = 0;
  public projectId: number = 0;
  public projectName: string = '';
  public shortProjectName: string = '';
  public packagingLCStages: Array<Stage> = [];
  public productLCStages: Array<Stage> = [];
  public packagingLevels: Array<Stage> = [];
  public productWestModeling: Array<any> = [];
  public shareId: number = 0;
  public statusId: number = 0;
  public organizationId: number = 0;
  public countryId: number = 0;
  public countryIds: Array<number> = [];
  public teamId: number = 0;
  public description: string = '';
  public specificWasteMaterialItems: Array<any> = [];
  public isTurnOffCost: boolean = false;
  public currencyId: number = 0;
  public notModal: boolean = false;
  public isLockProject: boolean = false;
  public allocationforRecycling: number = 0;
  public sKUDepartmentId: number | null = null;
  public sKUCategoryId: number | null = null;
  public sKUSubCategoryId: number | null = null;
  public ImpectCategoryJustification: string | undefined = undefined;
  public ProjectFileName: string | undefined = undefined;
  public ProjectImage: string | undefined = undefined;
  public otherAssumptionsOrLimitation: string | undefined = undefined;
  public productClassId: number | undefined = undefined;
  public productDepartmentId: number | undefined = undefined;
  public productFamilyId: number | undefined = undefined;
  public recycledCreditId: number | undefined = undefined;
  public sectorsIdentifierId: number | undefined = undefined;
  public systemBoundaryJustification: string | undefined = undefined;
}

export class Stage {
  public id: number = 0;
  public scopeId: number = 0;
  public projectId: number = 0;
  public scopeName: string = '';
  public projectScopeTypeId: number = 0;
}

export class ExtraDetails {
  id: number = 0;
  scenarioId: number = 0;
  unitsPerBox: string = '';
  boxesPerLayer: string = '';
  layersXPallet: string = '';
  totalWeightPerBox: string = '';
  totalHeight: string = '';
  totalWeight: string = '';
  supplierComments: string = '';
  productType: string = '';
  packDescription: string = '';
  material: string = '';
  renewableEnergy: string = '';
  manufacturedEMEA: string = '';
  supplierItemCode: string = '';
  packCode: string = '';
}

export class Scenario {
  name: string = '';
  owner: string = '';
  packageScenarioId: number = 0;
  projectId: number = 0;
  scenarioCode: string = '';
  scenarioId: number = 0;
  scenarioImage: string = '';
  scenarioPictureFileName: string = '';
  scenarioStatusId: number = 0;
  scenarioTypeId: number = 0;
  status: any = '';
  description: string = '';
  category: string = '';
  uuid: string = '';
  subCategory: string = '';
  department: string = '';
  year: string = '';
  scenarioNamePackaging: string = '';
  shortScenarioName: string = '';
  productClassId: number = 0;
  productFamilyId: number = 0;
  productDepartmentId: number = 0;
  isScenarioSpecificCategorization: boolean = false;
  orderId: number = 0;
  packagingLevelInfoList: PackagingLevelDetail[] = [];
  materialList: MaterialDetails[] = [];
  scenarioProductDetail?: ScenarioProductInformation;
  productDetailList: ProductDetails[] = [];
  palletConfiguration?: PalletConfiguration;
  endOfLifeCountryId: number = 0;
  extraDetails?: ExtraDetails;
}

export class MaterialDetails {
  name: string = '';
  scenarioId: number = 0;
  packageLevelId: number = 0;
  recylcableComponent: number = 0;
  materialSupplierId: number = 0;
  materialSupplierName: string = '';
  isCustomMaterial: boolean = false;
  materialWeight: number = 0;
  recycledContent: number = 0;
  materialCost: number = 0;
  conversionSupplierId: number | null = null;
  conversionProcessItems: ConversionProcessItem[] = [];
  isRecommendedConversionProcess: boolean = false;
  isAreaBaseConversionProcess: boolean = false;
  isAreaConversionProcess: boolean = false;
  areaBaseConversionProcess: number = 0;
  areaConversionId: number | null = null;
  isCustomConversion: boolean = false;
  componentId: number = 0;
  carbonNeutral: boolean = false;
  fscCertification: boolean = false;
  otherCertification: boolean = false;
  materialId: number = 0;
  customtransportScenarioId: any = null;
  customTransoportScenarioDetailViewModels: any[] = [];
  countryName: string = '';
  conversionPlaceName: string = '';
  conversionSupplierName: string = '';
  packageLevelInfoName: string = '';
  materialName: string = '';
  conversionCountryId: number = 0;
  materialCountryId: number = 0;
  isReuse: boolean = false;
  noOfTrips: number = 0;
  conversionProcessName: number = 0;
  reuseType: string = '';
  orderNo: number = 1;
  [key: string]: any;
}

export class PackagingLevelDetail {
  isActive: boolean = false;
  name: string = '';
  imageName: string = '';
  amount: number = 0;
  packagingLevelDetail: string = '';
  totalunitsperPallet: number = 0;
  packagingLevelId: number = 0;
  noOfUnit: number = 0;
  packagingLevelName: string = '';
  isLastChild: boolean = false;
}

export class ConversionProcessItem {
  componentId: number = 0;
  conversionCountryId: number = 0;
  conversionCountryName: string = '';
  conversionProcessId: number = 0;
  conversionProcessItems: any[] = [];
  conversionProcessName: string = '';
  conversionSupplierId: any = null;
  conversionSupplierName: string = '';
  id: number = 0;
  isAreaBaseConversionProcess: boolean = false;
  areaBaseConversionProcess: number = 0;
  areaConversionId: number | null = null;
  isCostTrunOff: boolean = false;
  isCustomConversion: boolean = false;
  isRecommendedConversionProcess: boolean = false;
}

export class TransportDetails {
  customSiteTransportId: number = 0;
  alwaysOrigin: boolean = false;
  id: number = 0;
  originId: number = 0;
  originName: string = '';
  transportModeName: string = '';
  distance: number = 0;
  isOrigin: boolean = false;
  isCustomTruck: boolean = false;
  isPalletLoad: boolean = false;
  productId: number = 0;
  locationDistance: number = 0;
  ingredientTransportId: number = 0;
  unit: string = '';
  transportModeId?: number = 0;
  persanteageMassLoad?: number = 0;
  index: number = 0;
  idStr: number = 0;
}

export class ProjectImportInfo {
  public ProjectConfiguration: ProjectDetails = new ProjectDetails();
  public ScenarioList: Scenario[] = [];
}

export class PackagingLevelDetailScenario {
  scenarioId: number = 0;
  packagingLevelDetail: PackagingLevelDetail[] = [];
}

export class ScenarioProductInformation {
  scenarioId: number = 0;
  packageScenarioId: number = 0;
  functionalUnitsPerProduct: number = 0;
  massVolume: number = 0;
  unitId: number = 0;
  bulkDensity: number = 0;
  annualRetailVolume: number = 0;
  sectorIdentifierId: number = 0;
  isSecIdentifierReq: boolean = false;
}

export class ProductDetails {
  name: string = '';
  productId: number = 0;
  ratio: number = 0;
  description: string = '';
  scenarioId: number = 0;
  packageScenarioId: number = 0;
  id: number = 0;
  isDescriptionChanged: boolean = false;
}

export class PalletConfiguration {
  id: number = 0;
  palletReusable: boolean = false;
  palletReuse: string = '';
  palletTypeId: number = 0;
  scenarioId: number = 0;
  isModified: boolean = false;
}

//End import project

export const Datatype = {
  Input: 1,
  PackagingLevelDropdown: 2,
  ProjectShareDropdown: 3,
  ProcessLocationDropdown: 4,
  DefaultLocationDropdown: 5,
  MaterialCountryDropdown: 6,
  MaterialDropdown: 7,
  PackagingConfiguration: 8,
  DepartmentDropdown: 9,
  CategoryDropdown: 10,
  SubCategoryDropdown: 11,
  UUID: 0,
  SuppliersDropdown: 12,
};

export enum CountryTypeEnum {
  Name = 1,
  Code2 = 2,
  Code3 = 3,
}

export class ExcelImportTemplateViewModel {
  public ProjectName: string = '';
  public ProjectNameUsedInReport: string = '';
  public ShareId: number = 0;
  public Share: string = '';
  public ProcessLocationId: number[] = [];
  public ProcessLocation: string = '';
  public DefaultCountryId: number = 0;
  public DefaultCountry: string = '';
  public PackagingConfigurationId: number[] = [];
  public PackagingConfiguration: string = '';
  public Department: string = '';
  public DepartmentId: number = 0;
  public Category: string = '';
  public CategoryId: number = 0;
  public SubCategory: string = '';
  public SubCategoryId: number = 0;
  public UUID: string = '';
  public CountryType: number = 1;
  public Scenarios: ScenarioConfiguration[] = [];
  [key: string]: any;
}

export class ScenarioConfiguration {
  public Id: number = 0;
  public ScenarioName: string = '';
  public ScenarioNameUsedInReport: string = '';
  public Components: ComponentConfiguration[] = [];
  [key: string]: any;
}

export class ComponentConfiguration {
  public Id: number = 0;
  public ScenarioId: number = 0;
  public ComponentName: string = '';
  public PackagingLevelId: number = 0;
  public PackagingLevel: string = '';
  public MaterialId: number = 0;
  public Material: string = '';
  public MaterialCountryId: number = 0;
  public MaterialCountry: string = '';
  public Weight: number = 0;
  public RecycledContentPercentage: number = 0;
  public Supplier: string = '';
  public SupplierId: number = 0;
  [key: string]: any;
}

//Automation start

export const ActionTypeEnum = {
  DemoWatched: 1,
  BeforeVideoStart: 2,
  AfterPurchase: 3,
  AfterSignUp: 4,
};

export const AutomationFlowTypeEnum = {
  DemoRequestAutomation: 1,
  TrialRequestAutomation: 2,
  PurchaseRequestAutomation: 3,
};

export enum AutomationStepTypeEnum {
  Email = 1,
  Delay = 2,
  UserAction = 3,
}

export const FixedDecimal = 3;

export const CK_EDITOR_CONFIG: any = {
  toolbar: [
    [
      'Source',
      'Templates',
      'Bold',
      'Italic',
      'Underline',
      'Strike',
      'Subscript',
      'Superscript',
      '-',
      'CopyFormatting',
      'RemoveFormat',
    ],
    ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'],
    ['Find', 'Replace', '-', 'SelectAll', '-', 'Scayt'],
    [
      'NumberedList',
      'BulletedList',
      '-',
      'Outdent',
      'Indent',
      '-',
      'Blockquote',
      'CreateDiv',
      '-',
      'JustifyLeft',
      'JustifyCenter',
      'JustifyRight',
      'JustifyBlock',
      '-',
      'BidiLtr',
      'BidiRtl',
    ],
    ['Link', 'Unlink', 'Anchor'],
    ['Image', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe'],
    ['Styles', 'Format', 'Font', 'FontSize'],
    ['TextColor', 'BGColor'],
    ['Maximize', 'ShowBlocks'],
  ],
  extraPlugins: 'font,image2,widget,lineutils,clipboard',
  font_names:
    'Arial/Arial, Helvetica, sans-serif;' +
    'Calibri/Calibri, sans-serif;' +
    'Times New Roman/Times New Roman, Times, serif;' +
    'Courier New/Courier New, Courier, monospace;' +
    'Georgia/Georgia, serif;' +
    'Tahoma/Tahoma, Geneva, sans-serif;' +
    'Verdana/Verdana, Geneva, sans-serif',
  disableNativeSpellChecker: false,
  versionCheck: false,
  removePlugins: 'scayt,image',
  allowedContent: true,
  removeFormatAttributes: '',
  fullPage: true,
  enterMode: 2,
  pasteFromWordRemoveFontStyles: false,
  pasteFromWordRemoveStyles: false,
  forcePasteAsPlainText: false,

  // Enhanced Image2 plugin configuration
  image2_alignClasses: ['image-left', 'image-center', 'image-right'],
  image2_captionedClass: 'image-captioned',
  image2_disableResizer: false,

  // Widget configuration for drag and drop
  widget_keystroke: {
    // Enable arrow keys for moving widgets
    40: 'moveDown', // down arrow
    38: 'moveUp', // up arrow
    39: 'moveRight', // right arrow
    37: 'moveLeft', // left arrow
  },

  // Enable drag and drop for widgets
  dragdrop_enable: true,

  // Additional widget settings
  widget: {
    // Enable drag handles
    dragHandleContainer: '.cke_widget_drag_handler_container',
  },

  // Custom CSS for better drag and drop experience
  contentsCss: [
    'https://cdn.ckeditor.com/4.15.0/standard-all/contents.css',
    'data:text/css,' +
      encodeURIComponent(`
      .cke_widget_image {
        position: relative !important;
      }

      .cke_widget_drag_handler {
        background: #007cff !important;
        border: 2px solid #fff !important;
        box-shadow: 0 0 4px rgba(0,0,0,0.3) !important;
        cursor: move !important;
        width: 16px !important;
        height: 16px !important;
      }

      .cke_widget_drag_handler:hover {
        background: #0056b3 !important;
      }

      .cke_widget_selected .cke_widget_drag_handler {
        display: block !important;
      }

      .cke_widget_image img {
        max-width: 100%;
        height: auto;
      }

      .cke_widget_wrapper {
        position: relative;
      }

      /* Drop zones styling */
      .cke_drop_target {
        border: 2px dashed #007cff !important;
        background: rgba(0, 124, 255, 0.1) !important;
        min-height: 20px !important;
      }

      /* Image alignment classes */
      .image-left {
        float: left;
        margin: 0 15px 15px 0;
      }

      .image-center {
        display: block;
        margin: 15px auto;
      }

      .image-right {
        float: right;
        margin: 0 0 15px 15px;
      }
    `),
  ],
};

export const ProductReportFormatEnum = [
  {
    id: 1,
    name: 'LCA report',
    description: 'LCA Report',
  },
];
export const ImportStatusEnum = {
  Pending: 1,
  Processing: 2,
  Error: 3,
  Success: 4,
  Fail: 5,
  ActionRequired: 6,
  Validated: 8,
  ValidationFailed: 9,
};

export const UPDATE_SCENARIO_EOL =
  'The latest EOL (End-of-Life) rates will be applied to all materials, based on your recent data. This may slightly change your results, helping improve accuracy. Updating this will reset all customized EOL Rates.';
export const UPDATE_SCENARIO_EOL_TITLE = 'Apply latest EOL rates?';

export const EOLEntrySource = {
  Manual: 1,
  System: 2,
  Custom: 3,
};

export enum ImportTypeEnum {
  CustomTemplate = 1,
  PiqetTemplate = 2,
  MasterTemplate = 3,
  MappingTemplate = 4,
}

export enum DistanceTypeEnum {
  ShipInternational = 1,
  AirInternational = 2,
  AirDomestic = 3,
}

export const CountryWithRegion = {
  Europe: 'europe (eu)',
  GlobalByProxy: ' (global by proxy)',
  EuropeByProxy: ' (europe by proxy)',
};

export const ITEM_TYPES = {
  DEPARTMENT: 1,
  FAMILY: 2,
  CLASS: 3,
} as const;

export const STORAGE_KEYS = {
  DEPARTMENT: 'newDepartmentItems',
  FAMILY: 'newFamilyItems',
  CLASS: 'newClassItems',
} as const;
export enum UpdatedByEnum {
  System = 1,
  SuperAdmin = 2,
  Trial = 3,
}

export enum LicenseDuration {
  SixMonths = '6 Months',
  OneYear = '1 Year',
  Custom = 'Custom',
}

export enum FeatureCodes {
  PROJECT_ORG_PACKAGING_FOOTPRINT = 'PROJECT:ORG_PACKAGING_FOOTPRINT',
  PROJECT_SYSTEM_BOUNDARY_JUSTIFICATION = 'PROJECT:SYSTEM_BOUNDARY_JUSTIFICATION',
  PROJECT_IMPACT_CATEGORY_JUSTIFICATION = 'PROJECT:IMPACT_CATEGORY_JUSTIFICATION',
  PROJECT_OTHER_ASSUMPTIONS_LIMITATIONS = 'PROJECT:OTHER_ASSUMPTIONS_LIMITATIONS',
  PROJECT_SIMPLE_SCOPE_PRESET = 'PROJECT:SIMPLE_SCOPE_PRESET',
  PROJECT_RETAIL_SCOPE_PRESET = 'PROJECT:RETAIL_SCOPE_PRESET',
  PROJECT_FULL_PACKAGE_AND_PRODUCT_LCA = 'PROJECT:FULL_PACKAGE_AND_PRODUCT_LCA',
  SCENARIO_SCENARIO_INTERNAL_DATA = 'SCENARIO:SCENARIO_INTERNAL_DATA',
  MATERIAL_BOOKED_MARKED_COMPONENTS = 'MATERIAL:BOOKED_MARKED_COMPONENTS',
  MATERIAL_MATERIAL_CERTIFICATION = 'MATERIAL:MATERIAL_CERTIFICATION',
  MATERIAL_CUSTOM_TRANSPORT = 'MATERIAL:CUSTOM_TRANSPORT',
  MATERIAL_CUSTOM_CONVERSION = 'MATERIAL:CUSTOM_CONVERSION',
  MATERIAL_CUSTOM_MATERIAL = 'MATERIAL:CUSTOM_MATERIAL',
  PRODUCT_PRODUCT_SECTOR_DATA = 'PRODUCT:PRODUCT_SECTOR_DATA',
  PRODUCT_FULL_PACKAGE_AND_PRODUCT_LCA = 'PRODUCT:FULL_PACKAGE_AND_PRODUCT_LCA',
  FILLING_CUSTOM_FILLING = 'FILLING:CUSTOM_FILLING',
  EOL_CUSTOM_END_OF_LIFE = 'EOL:CUSTOM_END_OF_LIFE',
  REPORTS_CHART_TYPE = 'REPORTS:CHART_TYPE',
  REPORTS_LIFE_CYCLE_STAGE = 'REPORTS:LIFE_CYCLE_STAGE',
  REPORTS_PACKAGING_LEVEL = 'REPORTS:PACKAGING_LEVEL',
  REPORTS_PACKAGING_COMPONENTS = 'REPORTS:PACKAGING_COMPONENTS',
  REPORTS_PRODUCT_LOSS = 'REPORTS:PRODUCT_LOSS',
  REPORTS_INGREDIENTS = 'REPORTS:INGREDIENTS',
  REPORTS_TRANSPORT = 'REPORTS:TRANSPORT',
  REPORTS_PEF_CATEGORIES_WITH_TOXICITY = 'REPORTS:PEF_CATEGORIES_WITH_TOXICITY',
  REPORTS_PEF_CATEGORIES_WITHOUT_TOXICITY = 'REPORTS:PEF_CATEGORIES_WITHOUT_TOXICITY',
  REPORTS_GLOBAL_PACKAGING_PROTOCOL_METRICS = 'REPORTS:GLOBAL_PACKAGING_PROTOCOL_METRICS',
  REPORTS_ALL_OTHER_METRICS = 'REPORTS:ALL_OTHER_METRICS',
  REPORTS_INTERPRETATION_SECTION = 'REPORTS:INTERPRETATION_SECTION',
  REPORTS_RAW_DATA_EXPORT = 'REPORTS:RAW_DATA_EXPORT',
  REPORTS_LCA_REPORT = 'REPORTS:LCA_REPORT',
  REPORTS_ISO_14044_LCA_REPORT = 'REPORTS:ISO_14044_LCA_REPORT',
  REPORTS_CUSTOM_REPORT = 'REPORTS:CUSTOM_REPORT',
  REPORTS_SENSITIVITY_ANALYSIS = 'REPORTS:SENSITIVITY_ANALYSIS',
  CUSTOM_MATERIAL = 'CUSTOM:MATERIAL',
  CUSTOM_CONVERSION = 'CUSTOM:CONVERSION',
  CUSTOM_TRUCKS = 'CUSTOM:TRUCKS',
  CUSTOM_TRANSPORT_CHAINS = 'CUSTOM:TRANSPORT_CHAINS',
  CUSTOM_FILLING = 'CUSTOM:FILLING',
  CUSTOM_STORAGE = 'CUSTOM:STORAGE',
  CUSTOM_REUSE = 'CUSTOM:REUSE',
  CUSTOM_WASTE_SCENARIOS = 'CUSTOM:WASTE_SCENARIOS',
  PREFERENCES_LIST_OF_SAVED_COMPONENTS = 'PREFERENCES:LIST_OF_SAVED_COMPONENTS',
  PREFERENCES_LIST_OF_SUPPLIERS = 'PREFERENCES:LIST_OF_SUPPLIERS',
  PREFERENCES_MATERIAL_CERTIFICATIONS = 'PREFERENCES:MATERIAL_CERTIFICATIONS',
  PREFERENCES_CUSTOM_INDICATORS = 'PREFERENCES:CUSTOM_INDICATORS',
  PREFERENCES_LITTER_IMPACT = 'PREFERENCES:LITTER_IMPACT',
  PREFERENCES_RECYCLED_CONTENT = 'PREFERENCES:RECYCLED_CONTENT',
  PREFERENCES_ORGANIZATION_WEIGHTINGS = 'PREFERENCES:ORGANIZATION_WEIGHTINGS',
  PREFERENCES_MANAGE_USERS_TEAMS_LOGIN = 'PREFERENCES:MANAGE_USERS_TEAMS_LOGIN',
  PREFERENCES_PROJECT_WORKFLOW = 'PREFERENCES:PROJECT_WORKFLOW',
  PREFERENCES_SCENARIO_WORKFLOW = 'PREFERENCES:SCENARIO_WORKFLOW',
  ADVANCED_ADD_INTERNAL_DATA = 'ADVANCED:ADD_INTERNAL_DATA',
  ADVANCED_ORG_PACKAGING_FOOTPRINT_REPORT = 'ADVANCED:ORG_PACKAGING_FOOTPRINT_REPORT',
  ADVANCED_EXPORT_LOGS = 'ADVANCED:EXPORT_LOGS',
  ADVANCED_IMPORT = 'ADVANCED:IMPORT',
  ADVANCED_PROJECT_REPORT_SETTINGS = 'ADVANCED:PROJECT_REPORT_SETTINGS',
  HELP_BASIC_GUIDED_TOUR = 'HELP:BASIC_GUIDED_TOUR',
  HELP_ADVANCED_GUIDED_TOUR = 'HELP:ADVANCED_GUIDED_TOUR',
  PRODUCT_PROJECT = 'DASHBOARD:PRODUCT_PROJECTS',
  CUSTOM_MATERIAL_CO2_EF_VALUE = 'CUSTOM:MATERIAL_CO2_EF_VALUE',
}

export const UserPreferenceType = {
  UpgradePlanPopup: 1,
};

export class SearchModel {
  search: string = '';
  pageSize?: number = 10;
  pageNumber?: number = 1;
  sortColumn: string = '';
  sortOrder: string = 'DESC';
  filterBy: number = 0;
  startDate?: Date | null = null;
  endDate?: Date | null = null;
  emailStatus: number = 0;
  organizationId: number = 0;
  userId: number = 0;
}

export interface UserActivity {
  userId: number;
  userName: string;
  organizationId: number;
  organizationName: string;
  activityDate: string;
  loginTime: string;
  logoutTime: string;
  endActivityType: number;
  durationMinutes: number;
}

export enum UserActivityTypeEnum {
  Login = 1,
  Logout = 2,
  SessionExtended = 3,
  SessionExpired = 4,
  NotifySessionExtension = 6,
  SimultaneousLoginDetected = 7,
  CrossOrganizationLogin = 8,
  InactiveTabDetected = 9,
  TabReloaded = 10,

  //Route wise
  DashboardVisit = 101,
  ProjectsVisit = 102,
  ProjectSettingVisit = 103,
  ScenarioListVisit = 104,
  ScenarioConfigurationVisit = 105,
  ScenarioMaterialListVisit = 106,
  ScenarioConversionListVisit = 107,
  ScenarioProductLossVisit = 108,
  ScenarioFillingListVisit = 109,
  ScenarioWholesaleListVisit = 110,
  ScenarioRetailListVisit = 111,
  ScenarioConsumerListVisit = 112,
  ScenarioEndOfLifeVisit = 113,
  ProjectChartAtGlanceVisit = 114,
  ProjectInterpretationVisit = 115,
  ProjectReportGenerationVisit = 116,
  CustomMaterialsVisit = 117,
  CustomConversionVisit = 118,
  CustomTrucksVisit = 119,
  CustomTransportVisit = 120,
  CustomFillingVisit = 121,
  CustomStorageVisit = 122,
  CustomReuseVisit = 123,
  WasteScenariosVisit = 124,
  OrganizationPreferencesVisit = 125,
  ManageUsersVisit = 126,
  ManageUserDetailsVisit = 127,
  ManageTeamsVisit = 128,
  ManageTeamDetailsVisit = 129,
  RolesVisit = 130,
  SSOSettingsVisit = 131,
  ManageProjectWorkflowVisit = 132,
  ManageScenarioWorkflowVisit = 133,
  TransactionsVisit = 134,
  EquivalencyUnitVisit = 135,
  OrganizationReportUploadSkuVisit = 136,
  OrganizationReportReportVisit = 137,
  ExportLogsVisit = 138,
  OrganizationReportImportPiqetTemplateVisit = 139,
  OrganizationReportImportCustomTemplateVisit = 140,
  OrganizationReportImportCustomTemplateAddVisit = 141,
  ProjectReportSettingVisit = 142,
  ProjectReportSettingDetailVisit = 143,
  Other = 999,
}

export const UserActivityTypeDescriptions: { [key in UserActivityTypeEnum]: string } = {
  [UserActivityTypeEnum.Login]: 'Logged in',
  [UserActivityTypeEnum.Logout]: 'Logged out',
  [UserActivityTypeEnum.SessionExtended]: 'Session extended',
  [UserActivityTypeEnum.SessionExpired]: 'Session expired',
  [UserActivityTypeEnum.NotifySessionExtension]: 'Notified to extend session',
  [UserActivityTypeEnum.SimultaneousLoginDetected]: 'Simultaneous login detected',
  [UserActivityTypeEnum.CrossOrganizationLogin]: 'Cross-organization login detected',
  [UserActivityTypeEnum.InactiveTabDetected]: 'Inactive browser tab detected',
  [UserActivityTypeEnum.TabReloaded]: 'Browser tab reloaded',

  [UserActivityTypeEnum.DashboardVisit]: 'Visited the dashboard page',
  [UserActivityTypeEnum.ProjectsVisit]: 'Visited the projects page',
  [UserActivityTypeEnum.ProjectSettingVisit]: 'Visited the project settings page',
  [UserActivityTypeEnum.ScenarioListVisit]: 'Visited the scenario list page',
  [UserActivityTypeEnum.ScenarioConfigurationVisit]: 'Visited the scenario configuration page',
  [UserActivityTypeEnum.ScenarioMaterialListVisit]: 'Visited the material list page',
  [UserActivityTypeEnum.ScenarioConversionListVisit]: 'Visited the conversion list page',
  [UserActivityTypeEnum.ScenarioProductLossVisit]: 'Visited the product loss page',
  [UserActivityTypeEnum.ScenarioFillingListVisit]: 'Visited the filling list page',
  [UserActivityTypeEnum.ScenarioWholesaleListVisit]: 'Visited the wholesale data list page',
  [UserActivityTypeEnum.ScenarioRetailListVisit]: 'Visited the retail list page',
  [UserActivityTypeEnum.ScenarioConsumerListVisit]: 'Visited the consumer list page',
  [UserActivityTypeEnum.ScenarioEndOfLifeVisit]: 'Visited the end of life page',
  [UserActivityTypeEnum.ProjectChartAtGlanceVisit]: 'Visited the project chart at glance page',
  [UserActivityTypeEnum.ProjectInterpretationVisit]: 'Visited the project interpretation page',
  [UserActivityTypeEnum.ProjectReportGenerationVisit]: 'Visited the project report generation page',
  [UserActivityTypeEnum.CustomMaterialsVisit]: 'Visited the custom materials page',
  [UserActivityTypeEnum.CustomConversionVisit]: 'Visited the custom conversion page',
  [UserActivityTypeEnum.CustomTrucksVisit]: 'Visited the custom trucks page',
  [UserActivityTypeEnum.CustomTransportVisit]: 'Visited the custom transport page',
  [UserActivityTypeEnum.CustomFillingVisit]: 'Visited the custom filling page',
  [UserActivityTypeEnum.CustomStorageVisit]: 'Visited the custom storage page',
  [UserActivityTypeEnum.CustomReuseVisit]: 'Visited the custom reuse page',
  [UserActivityTypeEnum.WasteScenariosVisit]: 'Visited the waste scenarios page',
  [UserActivityTypeEnum.OrganizationPreferencesVisit]: 'Visited the organization preferences page',
  [UserActivityTypeEnum.ManageUsersVisit]: 'Visited the manage users page',
  [UserActivityTypeEnum.ManageUserDetailsVisit]: 'Visited the manage user details page',
  [UserActivityTypeEnum.ManageTeamsVisit]: 'Visited the manage teams page',
  [UserActivityTypeEnum.ManageTeamDetailsVisit]: 'Visited the manage team details page',
  [UserActivityTypeEnum.RolesVisit]: 'Visited the roles page',
  [UserActivityTypeEnum.SSOSettingsVisit]: 'Visited the SSO settings page',
  [UserActivityTypeEnum.ManageProjectWorkflowVisit]: 'Visited the manage project workflow page',
  [UserActivityTypeEnum.ManageScenarioWorkflowVisit]: 'Visited the manage scenario workflow page',
  [UserActivityTypeEnum.TransactionsVisit]: 'Visited the transactions page',
  [UserActivityTypeEnum.EquivalencyUnitVisit]: 'Visited the equivalency unit page',
  [UserActivityTypeEnum.OrganizationReportUploadSkuVisit]:
    'Visited the organization report upload SKU page',
  [UserActivityTypeEnum.OrganizationReportReportVisit]: 'Visited the organization report page',
  [UserActivityTypeEnum.ExportLogsVisit]: 'Visited the export logs page',
  [UserActivityTypeEnum.OrganizationReportImportPiqetTemplateVisit]:
    'Visited the import PIQET template page',
  [UserActivityTypeEnum.OrganizationReportImportCustomTemplateVisit]:
    'Visited the import custom template page',
  [UserActivityTypeEnum.OrganizationReportImportCustomTemplateAddVisit]:
    'Visited the add custom template import page',
  [UserActivityTypeEnum.ProjectReportSettingVisit]: 'Visited the project report setting page',
  [UserActivityTypeEnum.ProjectReportSettingDetailVisit]:
    'Visited the project report setting detail page',
  [UserActivityTypeEnum.Other]: 'Visited other pages',
};

export const RouteToActivityTypeMap: { [route: string]: UserActivityTypeEnum } = {
  '/dashboard': UserActivityTypeEnum.DashboardVisit,
  '/projects': UserActivityTypeEnum.ProjectsVisit,
  '/projects/projects-setting/{id}/setting': UserActivityTypeEnum.ProjectSettingVisit,
  '/projects/projects-setting/{id}/scenario-list': UserActivityTypeEnum.ScenarioListVisit,
  '/projects/projects-setting/{id}/scenario-configuration':
    UserActivityTypeEnum.ScenarioConfigurationVisit,
  '/projects/projects-setting/{id}/material-list': UserActivityTypeEnum.ScenarioMaterialListVisit,
  '/projects/projects-setting/{id}/conversion-list':
    UserActivityTypeEnum.ScenarioConversionListVisit,
  '/projects/projects-setting/{id}/product-loss': UserActivityTypeEnum.ScenarioProductLossVisit,
  '/projects/projects-setting/{id}/fill-data-list': UserActivityTypeEnum.ScenarioFillingListVisit,
  '/projects/projects-setting/{id}/wholesale-data-list':
    UserActivityTypeEnum.ScenarioWholesaleListVisit,
  '/projects/projects-setting/{id}/retail-list': UserActivityTypeEnum.ScenarioRetailListVisit,
  '/projects/projects-setting/{id}/consumer-list': UserActivityTypeEnum.ScenarioConsumerListVisit,
  '/projects/projects-setting/{id}/end-of-life': UserActivityTypeEnum.ScenarioEndOfLifeVisit,
  '/projects/projects-setting/{id}/chart-at-glance': UserActivityTypeEnum.ProjectChartAtGlanceVisit,
  '/projects/projects-setting/{id}/interpretation': UserActivityTypeEnum.ProjectInterpretationVisit,
  '/projects/projects-setting/{id}/report-generation':
    UserActivityTypeEnum.ProjectReportGenerationVisit,
  '/custom/customMaterials': UserActivityTypeEnum.CustomMaterialsVisit,
  '/custom/customConversion': UserActivityTypeEnum.CustomConversionVisit,
  '/custom/customTrucks': UserActivityTypeEnum.CustomTrucksVisit,
  '/custom/customTransport': UserActivityTypeEnum.CustomTransportVisit,
  '/custom/customFilling': UserActivityTypeEnum.CustomFillingVisit,
  '/custom/customStorage': UserActivityTypeEnum.CustomStorageVisit,
  '/custom/customReuse': UserActivityTypeEnum.CustomReuseVisit,
  '/custom/wasteScenarios': UserActivityTypeEnum.WasteScenariosVisit,
  '/my-organization/organizationPreferences': UserActivityTypeEnum.OrganizationPreferencesVisit,
  '/my-organization/manageUsers': UserActivityTypeEnum.ManageUsersVisit,
  '/my-organization/manageUsers/details/{id}': UserActivityTypeEnum.ManageUserDetailsVisit,
  '/my-organization/manageTeams': UserActivityTypeEnum.ManageTeamsVisit,
  '/my-organization/manageTeams/details/{id}': UserActivityTypeEnum.ManageTeamDetailsVisit,
  '/my-organization/roles': UserActivityTypeEnum.RolesVisit,
  '/my-organization/SSOSettings': UserActivityTypeEnum.SSOSettingsVisit,
  '/my-organization/manageProjectWorkflow': UserActivityTypeEnum.ManageProjectWorkflowVisit,
  '/my-organization/manageScenarioWorkflow': UserActivityTypeEnum.ManageScenarioWorkflowVisit,
  '/my-organization/Transactions': UserActivityTypeEnum.TransactionsVisit,
  '/my-organization/equivalency-unit': UserActivityTypeEnum.EquivalencyUnitVisit,
  '/organization-report/upload-sku': UserActivityTypeEnum.OrganizationReportUploadSkuVisit,
  '/organization-report/report': UserActivityTypeEnum.OrganizationReportReportVisit,
  '/my-organization/exportLogs': UserActivityTypeEnum.ExportLogsVisit,
  '/organization-report/import-piqet-template':
    UserActivityTypeEnum.OrganizationReportImportPiqetTemplateVisit,
  '/organization-report/import-custom-template':
    UserActivityTypeEnum.OrganizationReportImportCustomTemplateVisit,
  '/organization-report/import-custom-template/add':
    UserActivityTypeEnum.OrganizationReportImportCustomTemplateAddVisit,
  '/my-organization/project-report-setting': UserActivityTypeEnum.ProjectReportSettingVisit,
  '/my-organization/project-report-setting/org-report-setting':
    UserActivityTypeEnum.ProjectReportSettingDetailVisit,
};

export enum AnalyticsTabsEnum {
  DASHBOARD = 'dashboard',
  SESSION = 'session',
  DEMOREQUEST = 'demoRequest',
}

export interface TabConfig {
  id: AnalyticsTabsEnum;
  label: string;
  route: string;
  icon?: string;
  description?: string;
  visible: boolean;
}

export const ANALYTICS_TABS: TabConfig[] = [
  {
    id: AnalyticsTabsEnum.DASHBOARD,
    label: 'Dashboard',
    route: '#/administrator/analytics',
    description: 'Overview of key performance indicators and activity trends',
    icon: 'bi-graph-up',
    visible: true,
  },
  {
    id: AnalyticsTabsEnum.DEMOREQUEST,
    label: 'Demo-Request Analytics',
    route: '#/administrator/analytics/demo-requests',
    description: 'Track and analyze demo requests submitted by users',
    icon: 'bi-person-lines-fill',
    visible: true,
  },
  {
    id: AnalyticsTabsEnum.SESSION,
    label: 'Session Analytics',
    route: '#/administrator/analytics/session',
    description: 'Detailed insights into user sessions and behavior patterns',
    icon: 'bi-bar-chart-line',
    visible: true,
  },
];

export const VERSION_STORAGE_KEY = 'app-version';
export const MAJOR_VERSION_STORAGE_KEY = 'major-version';

export enum LicenseType {
  Trial = 1,
  Purchase = 2,
}

export enum UserActionType {
  ADD_NEW = 'add_new',
  IMPORT = 'import',
  SHARE_LINK = 'share_link',
}

export enum ProjectType {
  PACKAGING_PROJECT = 1,
  PRODUCT_PROJECT = 2,
}
export enum projectsPlaceholder {
  PROCESS_COUNTRY_LABEL = 'Where will all of the processes be carried out?',
  PROCESS_COUNTRY = 'Select the countries where all processes will take place',
  DEFAULT_COUNTRY_LABEL = 'Highlight the default country where most processes will be carried out *',
  DEFAULT_COUNTRY = 'Select default country where most of the processes will be carried out',
}

export enum ReportFormLabels {
  REPORT_TITLE = 'Report title',
  REPORT_FORMAT = 'Report format',
  PRODUCTS = 'Products to include',
  FUNCTIONAL_UNIT = 'Functional unit',
  BASE_SCENARIO = 'Base scenario',
  PRODUCT_BASE_SCENARIO = 'Base product',
  IMPACT_CATEGORIES = 'Impact categories',
  CATEGORIES_INCLUDE = 'Categories to include',
}

export enum ReportFormPlaceholders {
  REPORT_TITLE = 'Enter report title',
  REPORT_FORMAT = 'Select the report format',
  PRODUCTS = 'Select products to include in the report',
  FUNCTIONAL_UNIT = 'Select functional unit',
  BASE_SCENARIO = 'Select base scenario',
  PRODUCT_BASE_SCENARIO = 'Select base product',
  IMPACT_CATEGORIES = 'Select impact categories to include',
  CATEGORIES_INCLUDE = 'Categories to include',
}
